import React, { useState, useEffect, useContext } from "react";
import Button from "../../common_components/Button";
import Modal from "../../common_components/Modal";



function ApplyConfirmationModal({ confirmAction, ...props }) {

    const notices = props.notices;
    // Reduce the list of notices to not include any that have the word "spots"
    const noticeList = notices.filter(notice => !notice.toLowerCase().includes("spots"));

    return (
        <Modal toggleModal={props.toggleModal} isOpen={props.isOpen} closeable={true} backgroundColor="dark">
            <div className="confirmation-modal-card">
                <div className="confirmation-modal-card-content">
                    <h1 className="confirmation-modal-card-content-title">
                        Accept requirements?
                    </h1>
                    <div className="confirmation-modal-card-content-message">
                        To complete this mission, you will need to meet the following requirements:
                        <ul className="apply-confirmation-modal-notice-list">
                            {noticeList.map(notice => (
                                <li className="apply-confirmation-modal-notice-bullet" key={notice}>{props.longNoticeMapping[notice]}</li>
                            ))}
                        </ul>
                    </div>
                </div>
                <div className="confirmation-modal-card-actions">
                    <Button color="gray" size="medium" onClick={props.toggleModal}>No, cancel</Button>
                    <Button color="primary" size="medium" onClick={confirmAction} >Yes, apply</Button>
                </div>
            </div>
        </Modal>
    )

}


export default ApplyConfirmationModal;